import axios from "axios";
const DEV_BASE_URL = 'http://offshorequalific.test/wp-content/themes/grensesnitt/scripts';
const PROD_BASE_URL = '/wp-content/themes/grensesnitt/scripts';
const BASE_URL = process.env.NODE_ENV === 'production' ? PROD_BASE_URL : DEV_BASE_URL;

export const CREDITSAFE_ENDPOINT = BASE_URL + '/creditsafe_post.php';
export const REGISTER_ENDPOINT = BASE_URL + '/oneflow_post.php';
export const FIND_COMPANY_ENDPOINT = BASE_URL + '/oneflow_find_company.php';

const searchForCompany = async (searchString, countryCode, recaptchaToken) => {
    const companyEncodedKey = encodeURIComponent('s');
    const companyEncodedValue = encodeURIComponent(searchString);
    const countryCodeEncodedKey = encodeURIComponent('country-code');
    const countryCodeEncodedValue = encodeURIComponent(countryCode);
    const recaptchaTokenEncodedKey = encodeURIComponent('token');
    const recaptchaTokenEncodedValue = encodeURIComponent(recaptchaToken);
    const body = `${companyEncodedKey}=${companyEncodedValue}&${countryCodeEncodedKey}=${countryCodeEncodedValue}&${recaptchaTokenEncodedKey}=${recaptchaTokenEncodedValue}`;

    const {data} = await axios.post(CREDITSAFE_ENDPOINT, body, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });

    return transformBisnodeResults(data);
}

export const submitAgiloftData = async (registrationData) => {
    
    const encodedKeyValue = (key, value) => {
        const encodedKey = encodeURIComponent(key);
        const encodedValue = encodeURIComponent(value || '');
        return encodedKey + "=" + encodedValue;
    }
    
    let bodyParts = [];
    bodyParts.push(encodedKeyValue('company_name', registrationData.companyName));
    bodyParts.push(encodedKeyValue('country', registrationData.country));
    bodyParts.push(encodedKeyValue('organization_id', registrationData.registrationNumber));
    bodyParts.push(encodedKeyValue('safeno', registrationData.safeNumber));
    bodyParts.push(encodedKeyValue('participant_category', registrationData.participantCategory));
    bodyParts.push(encodedKeyValue('epim_service_s_', (registrationData.services?.join ? registrationData.services?.join(',') : registrationData.services) || ''));
    bodyParts.push(encodedKeyValue('applicant_first_name', registrationData.primaryContract?.firstName));
    bodyParts.push(encodedKeyValue('applicant_last_name', registrationData.primaryContract?.lastName));
    bodyParts.push(encodedKeyValue('applicant_country', registrationData.primaryContract?.countryCode));
    bodyParts.push(encodedKeyValue('applicant_mobile', registrationData.primaryContract?.mobileNum));
    bodyParts.push(encodedKeyValue('applicant_email', registrationData.primaryContract?.email));
    bodyParts.push(encodedKeyValue('first_name_2', registrationData.secondaryContract?.firstName));
    bodyParts.push(encodedKeyValue('last_name_2', registrationData.secondaryContract?.lastName));
    bodyParts.push(encodedKeyValue('contract_administrator_2_country', registrationData.secondaryContract?.countryCode));
    bodyParts.push(encodedKeyValue('contract_administrator_2_mobile', registrationData.secondaryContract?.mobileNum));
    bodyParts.push(encodedKeyValue('email_2', registrationData.secondaryContract?.email));
    bodyParts.push(encodedKeyValue('nomination_code', registrationData.promotionCode));
    bodyParts.push(encodedKeyValue('recaptcha_token', registrationData.recaptchaToken));

    const {data} = await axios.post(REGISTER_ENDPOINT, bodyParts.join('&'), {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });

    return data;
}

export const findAgiloftCompany = async (organizationId, recaptchaToken) => {
    const encodedKey = encodeURIComponent('organization_id');
    const encodedValue = encodeURIComponent(organizationId);
    const recaptchaTokenEncodedKey = encodeURIComponent('token');
    const recaptchaTokenEncodedValue = encodeURIComponent(recaptchaToken);
    const body = `${encodedKey}=${encodedValue}&${recaptchaTokenEncodedKey}=${recaptchaTokenEncodedValue}`;

    const {data} = await axios.post(FIND_COMPANY_ENDPOINT, body, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });

    return data;
}

export const transformBisnodeResults = (json) => {
    const results = json.map(candidate => {
        const address = candidate.address;
        let addressComponents = [];

        const streetAddress1 = address?.street;
        if (streetAddress1) {
            addressComponents.push(streetAddress1);
        }

        const streetAddress2 = '';

        let postalCity = [];
        const zip = address.postCode;

        if (zip) {
            postalCity.push(zip);
        }

        const city = address.city;
        if (city) {
            postalCity.push(city);
        }

        if (postalCity.length > 0) {
            addressComponents.push(postalCity.join(' '));
        }

        const country = candidate.country;
        if (country) {
            addressComponents.push(country);
        }

        const addressConcatenated = addressComponents.join(', ');
        const name = candidate.name;
        const registrationNumber = candidate.regNo;
        const safeNumber = candidate.id;

        return {
            name,
            registrationNumber,
            safeNumber,
            addressConcatenated,
            streetAddress1,
            streetAddress2,
            zip,
            city,
            country
        }
    });

    return results || [];
}

const isoCountries = {
    'AF' : 'Afghanistan',
    'AX' : 'Aland Islands',
    'AL' : 'Albania',
    'DZ' : 'Algeria',
    'AS' : 'American Samoa',
    'AD' : 'Andorra',
    'AO' : 'Angola',
    'AI' : 'Anguilla',
    'AQ' : 'Antarctica',
    'AG' : 'Antigua And Barbuda',
    'AR' : 'Argentina',
    'AM' : 'Armenia',
    'AW' : 'Aruba',
    'AU' : 'Australia',
    'AT' : 'Austria',
    'AZ' : 'Azerbaijan',
    'BS' : 'Bahamas',
    'BH' : 'Bahrain',
    'BD' : 'Bangladesh',
    'BB' : 'Barbados',
    'BY' : 'Belarus',
    'BE' : 'Belgium',
    'BZ' : 'Belize',
    'BJ' : 'Benin',
    'BM' : 'Bermuda',
    'BT' : 'Bhutan',
    'BO' : 'Bolivia',
    'BA' : 'Bosnia And Herzegovina',
    'BW' : 'Botswana',
    'BV' : 'Bouvet Island',
    'BR' : 'Brazil',
    'IO' : 'British Indian Ocean Territory',
    'BN' : 'Brunei Darussalam',
    'BG' : 'Bulgaria',
    'BF' : 'Burkina Faso',
    'BI' : 'Burundi',
    'KH' : 'Cambodia',
    'CM' : 'Cameroon',
    'CA' : 'Canada',
    'CV' : 'Cape Verde',
    'KY' : 'Cayman Islands',
    'CF' : 'Central African Republic',
    'TD' : 'Chad',
    'CL' : 'Chile',
    'CN' : 'China',
    'CX' : 'Christmas Island',
    'CC' : 'Cocos (Keeling) Islands',
    'CO' : 'Colombia',
    'KM' : 'Comoros',
    'CG' : 'Congo',
    'CD' : 'Congo, Democratic Republic',
    'CK' : 'Cook Islands',
    'CR' : 'Costa Rica',
    'CI' : 'Cote D\'Ivoire',
    'HR' : 'Croatia',
    'CU' : 'Cuba',
    'CY' : 'Cyprus',
    'CZ' : 'Czech Republic',
    'DK' : 'Denmark',
    'DJ' : 'Djibouti',
    'DM' : 'Dominica',
    'DO' : 'Dominican Republic',
    'EC' : 'Ecuador',
    'EG' : 'Egypt',
    'SV' : 'El Salvador',
    'GQ' : 'Equatorial Guinea',
    'ER' : 'Eritrea',
    'EE' : 'Estonia',
    'ET' : 'Ethiopia',
    'FK' : 'Falkland Islands (Malvinas)',
    'FO' : 'Faroe Islands',
    'FJ' : 'Fiji',
    'FI' : 'Finland',
    'FR' : 'France',
    'GF' : 'French Guiana',
    'PF' : 'French Polynesia',
    'TF' : 'French Southern Territories',
    'GA' : 'Gabon',
    'GM' : 'Gambia',
    'GE' : 'Georgia',
    'DE' : 'Germany',
    'GH' : 'Ghana',
    'GI' : 'Gibraltar',
    'GR' : 'Greece',
    'GL' : 'Greenland',
    'GD' : 'Grenada',
    'GP' : 'Guadeloupe',
    'GU' : 'Guam',
    'GT' : 'Guatemala',
    'GG' : 'Guernsey',
    'GN' : 'Guinea',
    'GW' : 'Guinea-Bissau',
    'GY' : 'Guyana',
    'HT' : 'Haiti',
    'HM' : 'Heard Island & Mcdonald Islands',
    'VA' : 'Holy See (Vatican City State)',
    'HN' : 'Honduras',
    'HK' : 'Hong Kong',
    'HU' : 'Hungary',
    'IS' : 'Iceland',
    'IN' : 'India',
    'ID' : 'Indonesia',
    'IR' : 'Iran, Islamic Republic Of',
    'IQ' : 'Iraq',
    'IE' : 'Ireland',
    'IM' : 'Isle Of Man',
    'IL' : 'Israel',
    'IT' : 'Italy',
    'JM' : 'Jamaica',
    'JP' : 'Japan',
    'JE' : 'Jersey',
    'JO' : 'Jordan',
    'KZ' : 'Kazakhstan',
    'KE' : 'Kenya',
    'KI' : 'Kiribati',
    'KR' : 'South Korea',
    'KW' : 'Kuwait',
    'KG' : 'Kyrgyzstan',
    'LA' : 'Lao People\'s Democratic Republic',
    'LV' : 'Latvia',
    'LB' : 'Lebanon',
    'LS' : 'Lesotho',
    'LR' : 'Liberia',
    'LY' : 'Libyan Arab Jamahiriya',
    'LI' : 'Liechtenstein',
    'LT' : 'Lithuania',
    'LU' : 'Luxembourg',
    'MO' : 'Macao',
    'MK' : 'Macedonia',
    'MG' : 'Madagascar',
    'MW' : 'Malawi',
    'MY' : 'Malaysia',
    'MV' : 'Maldives',
    'ML' : 'Mali',
    'MT' : 'Malta',
    'MH' : 'Marshall Islands',
    'MQ' : 'Martinique',
    'MR' : 'Mauritania',
    'MU' : 'Mauritius',
    'YT' : 'Mayotte',
    'MX' : 'Mexico',
    'FM' : 'Micronesia, Federated States Of',
    'MD' : 'Moldova',
    'MC' : 'Monaco',
    'MN' : 'Mongolia',
    'ME' : 'Montenegro',
    'MS' : 'Montserrat',
    'MA' : 'Morocco',
    'MZ' : 'Mozambique',
    'MM' : 'Myanmar',
    'NA' : 'Namibia',
    'NR' : 'Nauru',
    'NP' : 'Nepal',
    'NL' : 'Netherlands',
    'AN' : 'Netherlands Antilles',
    'NC' : 'New Caledonia',
    'NZ' : 'New Zealand',
    'NI' : 'Nicaragua',
    'NE' : 'Niger',
    'NG' : 'Nigeria',
    'NU' : 'Niue',
    'NF' : 'Norfolk Island',
    'MP' : 'Northern Mariana Islands',
    'NO' : 'Norway',
    'OM' : 'Oman',
    'PK' : 'Pakistan',
    'PW' : 'Palau',
    'PS' : 'Palestinian Territory, Occupied',
    'PA' : 'Panama',
    'PG' : 'Papua New Guinea',
    'PY' : 'Paraguay',
    'PE' : 'Peru',
    'PH' : 'Philippines',
    'PN' : 'Pitcairn',
    'PL' : 'Poland',
    'PT' : 'Portugal',
    'PR' : 'Puerto Rico',
    'QA' : 'Qatar',
    'RE' : 'Reunion',
    'RO' : 'Romania',
    'RU' : 'Russian Federation',
    'RW' : 'Rwanda',
    'BL' : 'Saint Barthelemy',
    'SH' : 'Saint Helena',
    'KN' : 'Saint Kitts And Nevis',
    'LC' : 'Saint Lucia',
    'MF' : 'Saint Martin',
    'PM' : 'Saint Pierre And Miquelon',
    'VC' : 'Saint Vincent And Grenadines',
    'WS' : 'Samoa',
    'SM' : 'San Marino',
    'ST' : 'Sao Tome And Principe',
    'SA' : 'Saudi Arabia',
    'SN' : 'Senegal',
    'RS' : 'Serbia',
    'SC' : 'Seychelles',
    'SL' : 'Sierra Leone',
    'SG' : 'Singapore',
    'SK' : 'Slovakia',
    'SI' : 'Slovenia',
    'SB' : 'Solomon Islands',
    'SO' : 'Somalia',
    'ZA' : 'South Africa',
    'GS' : 'South Georgia And Sandwich Isl.',
    'ES' : 'Spain',
    'LK' : 'Sri Lanka',
    'SD' : 'Sudan',
    'SR' : 'Suriname',
    'SJ' : 'Svalbard And Jan Mayen',
    'SZ' : 'Swaziland',
    'SE' : 'Sweden',
    'CH' : 'Switzerland',
    'SY' : 'Syrian Arab Republic',
    'TW' : 'Taiwan',
    'TJ' : 'Tajikistan',
    'TZ' : 'Tanzania',
    'TH' : 'Thailand',
    'TL' : 'Timor-Leste',
    'TG' : 'Togo',
    'TK' : 'Tokelau',
    'TO' : 'Tonga',
    'TT' : 'Trinidad And Tobago',
    'TN' : 'Tunisia',
    'TR' : 'Turkey',
    'TM' : 'Turkmenistan',
    'TC' : 'Turks And Caicos Islands',
    'TV' : 'Tuvalu',
    'UG' : 'Uganda',
    'UA' : 'Ukraine',
    'AE' : 'United Arab Emirates',
    'GB' : 'United Kingdom',
    'US' : 'United States',
    'UM' : 'United States Outlying Islands',
    'UY' : 'Uruguay',
    'UZ' : 'Uzbekistan',
    'VU' : 'Vanuatu',
    'VE' : 'Venezuela',
    'VN' : 'Viet Nam',
    'VG' : 'Virgin Islands, British',
    'VI' : 'Virgin Islands, U.S.',
    'WF' : 'Wallis And Futuna',
    'EH' : 'Western Sahara',
    'YE' : 'Yemen',
    'ZM' : 'Zambia',
    'ZW' : 'Zimbabwe'
};

function getCountryName (countryCode) {
    if (isoCountries.hasOwnProperty(countryCode)) {
        return isoCountries[countryCode];
    } else {
        return countryCode;
    }
}

const api = {
    searchForCompany,
    submitAgiloftData,
    findAgiloftCompany,
}

export default api
